export enum TipoConteudoInternoEnum {
    CURSO_LIVRE = 'CURSO_LIVRE',
    ITEM_BIBLIOTECA = 'ITEM_BIBLIOTECA',
    UNKNOWN = '',
}
